import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=37068593&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=37068593&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports